export default "__VITE_ASSET__gHpBieiq__"